(function ($) {
    'use strict';

    $(function () {
        console.log('Tombstones load more script loaded');
        
        // Handle load more button clicks
        $(document).on('click', '.tombstones-load-more-btn', function(e) {
            e.preventDefault();
            console.log('Load more button clicked');
            
            var $button = $(this);
            var $container = $button.closest('.tombstones-container');
            var $tombstonesGrid = $container.find('.tombstones-grid');
            var nextPage = parseInt($button.attr('data-next-page'));
            var totalItems = parseInt($container.attr('data-total'));
            var perPage = parseInt($container.attr('data-per-page'));
            
            console.log('Next page:', nextPage, 'Total items:', totalItems, 'Per page:', perPage);
            
            // Check if tombstones data is available
            if (typeof window.tombstonesData === 'undefined') {
                console.error('Tombstones data not found');
                return;
            }
            
            // Disable button during loading
            $button.prop('disabled', true).text('Loading...');
            
            // Calculate offset for next page
            var offset = (nextPage - 1) * perPage;
            
            console.log('Offset:', offset, 'Next page:', nextPage, 'Per page:', perPage);
            console.log('Total data items:', window.tombstonesData.length);
            
            // Get items for next page
            var nextItems = window.tombstonesData.slice(offset, offset + perPage);
            
            console.log('Next items count:', nextItems.length);
            console.log('Items range:', offset, 'to', offset + perPage);
            
            // Build HTML for new items
            var html = '';
            nextItems.forEach(function(image) {
                html += '<div class="tombstone-item">';
                html += '<div class="-image">';
                html += '<img src="' + image.url + '" alt="' + (image.title || '') + '" />';
                html += '</div>';
                html += '</div>';
            });
            
            // Append new items to the tombstones grid
            $tombstonesGrid.append(html);
            
            // Update container data attributes
            $container.attr('data-current-page', nextPage);
            
            // Check if there are more items
            var currentTotalLoaded = nextPage * perPage;
            var hasMore = currentTotalLoaded < totalItems;
            
            console.log('Current total loaded:', currentTotalLoaded, 'Has more:', hasMore);
            
            if (hasMore) {
                // Update button for next page
                $button.attr('data-next-page', nextPage + 1).prop('disabled', false).text('Load More');
            } else {
                // Hide button if no more items
                $button.hide();
            }
        });
        
    });

})(jQuery); 